import "./style/CreateMeeting.css";
import React, { useEffect, useState } from "react";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
//added for meeting dropdown
import Dropdown from "react-bootstrap/Dropdown";
import MeetingDropDown from "../Meeting/MeetingDropDown";
import "./style/meetings-css.css";
import EditMeeting from "./EditMeeting";
import {
  processCancelMeeting, //added for meeting dropdown
} from "../../redux/actions/meetingActions/MeetingAction";
import {
  getSingleMeetingDetails,
  unSetSingleMeetingDetails,
  updateStep,
  processdeleteMeeting,
} from "../../redux/actions/meetingActions/MeetingAction";
import ViewMeeting from "./ViewMeeting";
import { logOut } from "../../redux/actions/authActions/authAction";
import RescheduleMeetingModal from "./RescheduleMeetingModal";
import ResendMeetingDetailsModal from "./ResendMeetingDetailsModal";
import CancelMeetingModal from "./CancelMeetingModal";
import DeleteMeetingModal from "./DeleteMeetingModal";
import BackButton from "../Common/Backbutton";

const EditMeetingPage = React.memo(() => {
  const location = useLocation();
  const stateData = location.state;
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const meetingData = useSelector((state) => state.meeting);

  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );

  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
  const [meetingId, setMeetingId] = useState(null);

  const [singleMeetingDetails, setSingleMeetingDetails] = useState(null);
  const [isResendMeetingDetailsModalOpen, setIsResendMeetingDetailsModalOpen] =
    useState(false);
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const [isDeleteMeetingModalOpen, setIsDeleteMeetingModalOpen] =
    useState(false);
  const navigate = useNavigate();
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    if (stateData?.meetingId) {
      dispatch(getSingleMeetingDetails(stateData?.meetingId, accessToken));
    }

    return () => {
      dispatch(unSetSingleMeetingDetails());

      dispatch(updateStep(0));
    };
  }, []);
  const handleCancelModal = (meetingId) => {
    setMeetingId(meetingId);
    setIsCancelModalOpen(true);
  };
  const handleResendMeetingDetailsModal = (singleMeetingDetails) => {
    setSingleMeetingDetails(singleMeetingDetails);

    setIsResendMeetingDetailsModalOpen(true);
  };
  const handleCloseModal = (meetingId) => {
    setMeetingId(meetingId);
    setIsCloseModalOpen(true);
  };

  const handleRescheduleModal = (singleMeetingDetails) => {
    setSingleMeetingDetails(singleMeetingDetails);

    setIsRescheduleModalOpen(true);
  };
  //modals for meeting dropdown
  const handleCancelMeeting = (remarks) => {
    dispatch(processCancelMeeting(meetingId, { remarks }, accessToken));
    setMeetingId(null);
    setIsCancelModalOpen(false);
  };

  ////////////// delete meeting //////////////

  const handleDeleteModal = (meetingId) => {
    setMeetingId(meetingId);
    setIsDeleteMeetingModalOpen(true);
  };

  const handleDeleteMeeting = () => {
    dispatch(processdeleteMeeting(meetingId, accessToken));
    setMeetingId(null);
    setTimeout(() => {
      navigate("/meeting-list");
    }, 500);
  };

  ///////////////////////////

  return (
    <>
      {!stateData?.meetingId ? <Navigate to="/meeting-list" /> : null}

      <div className="main-content">
        <div className="row">
          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
            <div className="d-flex align-items-center justify-content-between">
              <div className="meeting-header-text line-height-h4">
                <h4>Meeting Preview</h4>
              </div>
              <div className="d-flex align-items-center justify-content-between gap-8px resp-d-none">
                {meetingData?.singleMeetingDetails && (
                  <div className="d-inline-block menu-dropdown custom-dropdown">
                    <Dropdown>
                      <MeetingDropDown
                        meetingDetails={meetingData?.singleMeetingDetails}
                        meetingId={meetingData?.singleMeetingDetails?._id}
                        status={
                          meetingData?.singleMeetingDetails?.meetingStatus
                            ?.status
                        }
                        handleCancelModal={(meetingId) => {
                          handleCancelModal(
                            meetingData?.singleMeetingDetails?._id
                          );
                        }}
                        handleResendMeetingDetailsModal={() => {
                          handleResendMeetingDetailsModal(
                            meetingData?.singleMeetingDetails
                          );
                        }}
                        handleRescheduleModal={() => {
                          handleRescheduleModal(
                            meetingData?.singleMeetingDetails
                          );
                        }}
                        handleCloseModal={() => {
                          handleCloseModal(
                            meetingData?.singleMeetingDetails?._id
                          );
                        }}
                        handleDeleteModal={(meetingId) => {
                          handleDeleteModal(
                            meetingData?.singleMeetingDetails?._id
                          );
                        }}
                      />
                    </Dropdown>
                  </div>
                )}
                <BackButton show={camefromPreviousPage} />
              </div>
            </div>
            <ViewMeeting />
          </div>
          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
            <div className="meeting-header-text respmt-20 line-height-h4">
              <h4>Edit Meeting Details</h4>
              {/* Added for Meeting dropdown */}
              <div className="d-flex g-10 mobile-hide">
                {meetingData?.singleMeetingDetails && (
                  <div className="d-inline-block menu-dropdown custom-dropdown">
                    <Dropdown>
                      <MeetingDropDown
                        meetingDetails={meetingData?.singleMeetingDetails}
                        meetingId={meetingData?.singleMeetingDetails?._id}
                        status={
                          meetingData?.singleMeetingDetails?.meetingStatus
                            ?.status
                        }
                        handleCancelModal={(meetingId) => {
                          handleCancelModal(
                            meetingData?.singleMeetingDetails?._id
                          );
                        }}
                        handleResendMeetingDetailsModal={() => {
                          handleResendMeetingDetailsModal(
                            meetingData?.singleMeetingDetails
                          );
                        }}
                        handleRescheduleModal={() => {
                          handleRescheduleModal(
                            meetingData?.singleMeetingDetails
                          );
                        }}
                        handleCloseModal={() => {
                          handleCloseModal(
                            meetingData?.singleMeetingDetails?._id
                          );
                        }}
                        handleDeleteModal={(meetingId) => {
                          handleDeleteModal(
                            meetingData?.singleMeetingDetails?._id
                          );
                        }}
                      />
                    </Dropdown>
                  </div>
                )}

                <BackButton show={camefromPreviousPage} />
              </div>
            </div>
            <EditMeeting />
          </div>
        </div>
      </div>
      <RescheduleMeetingModal
        setIsRescheduleModalOpen={setIsRescheduleModalOpen}
        isRescheduleModalOpen={isRescheduleModalOpen}
        meetingData={singleMeetingDetails}
        isFetchedMeetingList={meetingData.isFetchedMeetingList}
      />
      <ResendMeetingDetailsModal
        isResendMeetingDetailsModalOpen={isResendMeetingDetailsModalOpen}
        setIsResendMeetingDetailsModalOpen={setIsResendMeetingDetailsModalOpen}
        meetingDetail={singleMeetingDetails}
      />
      <CancelMeetingModal
        setIsModalOpen={setIsCancelModalOpen}
        isModalOpen={isCancelModalOpen}
        handleSubmit={handleCancelMeeting}
      />
      <DeleteMeetingModal
        setIsModalOpen={setIsDeleteMeetingModalOpen}
        isModalOpen={isDeleteMeetingModalOpen}
        handleSubmit={handleDeleteMeeting}
      />
    </>
  );
});

export default EditMeetingPage;
